import React from 'react';
import { AnimatePresence, motion } from 'framer-motion';
import { CheckCircle2Icon, XCircleIcon, XIcon } from 'lucide-react';
import type { ToastMessage } from '../../types/offboarding';
interface ToastStackProps {
  toasts: ToastMessage[];
  onDismiss: (id: number) => void;
}
export function ToastStack({
  toasts,
  onDismiss
}: ToastStackProps) {
  return <div className="pointer-events-none fixed right-4 top-4 z-[60] flex w-[calc(100%-2rem)] flex-col gap-2 sm:w-96" aria-live="polite" data-id="element-307" data-mp="3tfjfkxkq3id0">
      <AnimatePresence initial={false} data-id="element-308" data-mp="pzufy9v7p3mp">
        {toasts.map(toast => {
        const isSuccess = toast.variant === 'success';
        const Icon = isSuccess ? CheckCircle2Icon : XCircleIcon;
        return <motion.div key={toast.id} layout initial={{
          opacity: 0,
          y: -8,
          scale: 0.96
        }} animate={{
          opacity: 1,
          y: 0,
          scale: 1
        }} exit={{
          opacity: 0,
          scale: 0.96
        }} transition={{
          duration: 0.2,
          ease: [0.23, 1, 0.32, 1]
        }} role={isSuccess ? 'status' : 'alert'} className="pointer-events-auto flex gap-3 rounded-lg border border-gray-200 bg-white p-4 shadow-lg" data-id="element-309" data-mp="g14w4bjr993t">
              <Icon className={`mt-0.5 h-5 w-5 flex-shrink-0 ${isSuccess ? 'text-success' : 'text-danger'}`} aria-hidden="true" data-id="element-310" data-mp="29uktv9jvhlrw" />
              <div className="min-w-0 flex-1" data-id="element-311" data-mp="2jrfohhd0z20w">
                <p className="text-sm font-semibold text-gray-900" data-id="element-312" data-mp="2jq4q5x2cmmh6">{toast.title}</p>
                <p className="mt-0.5 text-[13px] text-gray-600" data-id="element-313" data-mp="2escxh0tvqwbx">{toast.message}</p>
              </div>
              <button type="button" onClick={() => onDismiss(toast.id)} aria-label="Dismiss notification" className="-mr-1 -mt-1 flex h-7 w-7 flex-shrink-0 items-center justify-center rounded-md text-gray-400 transition-colors hover:bg-gray-100 hover:text-gray-700" data-id="element-314" data-mp="2th93ytgag1af">
                <XIcon className="h-4 w-4" data-id="element-315" data-mp="1v67tylrsfcqj" />
              </button>
            </motion.div>;
      })}
      </AnimatePresence>
    </div>;
}